import styled from 'styled-components6';

const CarouselDot = styled.div`
    height: 6px;
    width: 6px;
    border-radius: 50%;
    &.active-dot {
        transition: transform 0.3s ease;
        transform: scale(1.15);
        background-color: var(--rwl-palette-white);
    }
    &.dot {
        background-color: var(--rwl-palette-gray-200);
    }
    &.has-more {
        transform: scale(0.5);
    }
    cursor: pointer;
`;

const CarouselDotContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: var(--rwl-spacing-sm);
    padding: 2px var(--rwl-spacing-xs);
    gap: var(--rwl-spacing-xs);
    position: absolute;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.3);
    border-radius: var(--rwl-radius-md);
`;

type CarouselDotsProps = {
    totalImages: number;
    currentImageIndex: number;
    setCurrentImageIndex: (index: number) => void;
};

export const CarouselDots = ({
    totalImages,
    currentImageIndex,
    setCurrentImageIndex,
}: CarouselDotsProps): JSX.Element => {
    const maxDotsToShow = 5;

    const goToImage = (index: number) => {
        setCurrentImageIndex(index);
    };

    let startDotIndex = Math.max(0, currentImageIndex - 2);
    let endDotIndex = Math.min(
        totalImages - 1,
        startDotIndex + maxDotsToShow - 1
    );

    if (endDotIndex - startDotIndex < maxDotsToShow - 1) {
        startDotIndex = Math.max(0, totalImages - maxDotsToShow);
        endDotIndex = totalImages - 1;
    }

    return (
        <CarouselDotContainer className="carousel-dots">
            {Array.from({ length: maxDotsToShow }, (_, index) => {
                const dotIndex = startDotIndex + index;
                return dotIndex <= endDotIndex ? (
                    <CarouselDot
                        key={dotIndex}
                        className={`
                    ${dotIndex === currentImageIndex ? 'active-dot' : 'dot'}
                    ${
                        dotIndex === endDotIndex &&
                        endDotIndex < totalImages - 1
                            ? 'has-more'
                            : ''
                    }
                `}
                        onClick={() => goToImage(dotIndex)}
                    />
                ) : null;
            })}
        </CarouselDotContainer>
    );
};
